import { createElement } from 'src/app/core/helpers/dom';
import { humanizePriority } from 'src/app/project/modules/points/priorities';
import { TColumn } from '../../columns/column.model';
import { GET_TABLE } from '../../table.ui.store';
import { createCellElement } from '../createCellElement';

export function createPriorityElement(_index: number, _column: TColumn): HTMLElement {
  const table = GET_TABLE();

  return createCellElement({
    index: _column.index,
    width: `${_column.width}px`,
    center: true,
    child: createElement('div', {
      attrs: {
        class: `customSiteTable__priorityIndicator customSiteTable__priority--${table.getPoints()[_index].priority}`,
        title: humanizePriority(table.getPoints()[_index].priority),
      },
    }),
  });
}
